import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight, FiCheck } from "react-icons/fi";
import Frame from "../layout/Frame";
import Meta from "../layout/Meta";
import Outcomes from "../blocks/Outcomes";
import Services from "../blocks/Services";
import Channels from "../blocks/Channels";
import Pulse from "../blocks/Pulse";
import Invite from "../blocks/Invite";

const Home = () => (
  <Frame>
    <Meta />

    {/* HERO */}
    <section className="hero">
      <div className="shell">
        <div className="layout">
          <div>
            <div className="head-tags">
              <span className="tag tag--orange">PERFORMANCE ADVERTISING</span>
              <span className="tag tag--ghost">EST. NTAC</span>
            </div>
            <h1>Spend that moves the <em>P&amp;L.</em> Not just the dashboard.</h1>
            <p className="lede" style={{ marginTop: "1.5rem" }}>
              NTAC is a performance advertising shop. Paid search, paid social, programmatic, CTV and retail media —
              bought against incremental contribution, measured incrementally, and reported in CFO language every month.
            </p>
            <div className="signature">
              <Link to="/services" className="btn btn--orange">
                See services <FiArrowRight />
              </Link>
              <Link to="/contact" className="btn btn--line">
                Brief us
              </Link>
            </div>
          </div>

          {/* Dashboard board */}
          <div className="board">
            <div className="board-head">
              <span>account · acme-dtc · q2 2026</span>
              <span className="live">LIVE</span>
            </div>
            <div className="cell cell-1">
              <div className="lbl">ROAS · 28d</div>
              <div className="v up">+312%</div>
              <div className="delta">vs. prior 28d · sig p&lt;0.01</div>
            </div>
            <div className="cell cell-2">
              <div className="lbl">CPA</div>
              <div className="v">€18.40</div>
              <div className="delta">−41% vs. quarter open</div>
            </div>
            <div className="cell cell-3">
              <div className="lbl">INCR. LIFT</div>
              <div className="v up">+8.4x</div>
              <div className="delta">geo-holdout · 4-mkt test</div>
            </div>
            <div className="cell cell-4">
              <div className="lbl">CONTRIB. MARGIN</div>
              <div className="v">€428k</div>
              <div className="delta">net new · this quarter</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Outcomes />

    {/* SERVICES */}
    <section className="band">
      <div className="shell">
        <div className="head-block">
          <div className="left">
            <span className="tag">SERVICES</span>
            <h2>Eight paid-media practices. One accountable team.</h2>
            <p>Each can run standalone. Most engagements combine four or more — sequenced against where the spend actually is today.</p>
          </div>
          <div className="right">
            <Link to="/services" className="btn btn--line">All services <FiArrowUpRight /></Link>
          </div>
        </div>
        <Services limit={6} />
      </div>
    </section>

    {/* CHANNELS */}
    <section className="band band--paper">
      <div className="shell">
        <div className="head-block">
          <div className="left">
            <span className="tag">CHANNELS</span>
            <h2>Eight channels. One unified bid + measurement loop.</h2>
            <p>We trade across the full performance stack and reconcile measurement against a single warehouse — not platform self-reports.</p>
          </div>
        </div>
        <Channels />
      </div>
    </section>

    {/* WHY */}
    <section className="band">
      <div className="shell">
        <div className="duet">
          <div>
            <span className="tag">WHY NTAC</span>
            <h2 style={{ marginTop: "1.25rem" }}>Built for the CFO's question.</h2>
            <p>
              Most performance shops report against platform metrics that flatter the relationship and obscure the
              business. NTAC reports against the business: incremental revenue, contribution margin, payback period.
            </p>
            <ul className="tick">
              <li><span className="m"><FiCheck /></span> Incrementality testing baked into every campaign cycle</li>
              <li><span className="m"><FiCheck /></span> Creative velocity matched to platform appetite</li>
              <li><span className="m"><FiCheck /></span> SKU-level profitability instrumentation</li>
              <li><span className="m"><FiCheck /></span> CFO-language reporting, every month, in writing</li>
            </ul>
            <div style={{ marginTop: "2rem" }}>
              <Link to="/studio" className="btn btn--ink">About the studio <FiArrowUpRight /></Link>
            </div>
          </div>
          <div className="outcome-card">
            <div className="head">
              <span>OUTCOME · ACME-DTC</span>
              <span className="label">VERIFIED</span>
            </div>
            <div className="big">+8.4x</div>
            <p className="desc">Incremental sales lift confirmed via geo-holdout testing across four markets, after rebuilding the bid + creative loop in NTAC's first quarter.</p>
            <div className="grid-meta">
              <div>
                <div className="k">TEST DESIGN</div>
                <div className="v">Geo-holdout · 12 wks</div>
              </div>
              <div>
                <div className="k">CHANNELS</div>
                <div className="v">Meta + Google + CTV</div>
              </div>
              <div>
                <div className="k">SIGNIFICANCE</div>
                <div className="v">p &lt; 0.01</div>
              </div>
              <div>
                <div className="k">PAYBACK</div>
                <div className="v">11 days</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* PULSE */}
    <section className="band band--paper">
      <div className="shell">
        <div className="head-block">
          <div className="left">
            <span className="tag">PULSE</span>
            <h2>Field notes from the trading desk.</h2>
            <p>Quarterly readouts on the channels we run — what's working, what's broken, what's changing.</p>
          </div>
          <div className="right">
            <Link to="/pulse" className="btn btn--line">All pulse notes <FiArrowUpRight /></Link>
          </div>
        </div>
        <Pulse />
      </div>
    </section>

    <Invite />
  </Frame>
);

export default Home;
